import React, { memo } from 'react';
import GeneralDialog from '../../GeneralDialog';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components/macro';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Colors from '../../Colors';
import useTranslations from '../../../hooks/useTranslations';

const DraggableItem = styled.div`
  background-color: #fff;
  border-bottom: 1px solid ${Colors.BORDER_GREY};
  position: relative;
`;

const SectionSizeText = styled.span`
  color: ${Colors.BORDER_GREY};
  font-size: 14px;
  position: absolute;
  right: 0;
`;

const UntitledSection = styled.span`
  color: ${Colors.BORDER_GREY};
`;

const ReorderSectionsDialogView = props => {
  const t = useTranslations();
  const DraggableSection = ({ title, index, internalId, sectionSize }) => {
    return (
      <Draggable draggableId={internalId} index={index} key={internalId}>
        {provided => (
          <DraggableItem
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <ListItem>
              <ListItemIcon>
                <DragHandleIcon />
              </ListItemIcon>
              {title ? (
                title
              ) : (
                <UntitledSection>Untitled section</UntitledSection>
              )}{' '}
              <SectionSizeText>
                ({t('reorder_sections.count.text', { fieldCount: sectionSize })}
                )
              </SectionSizeText>
            </ListItem>
          </DraggableItem>
        )}
      </Draggable>
    );
  };
  const ListOfDraggableSections = memo(({ sections }) => {
    return sections.map(({ title, index, internalId, sectionSize }) => (
      <DraggableSection
        title={title}
        index={index}
        internalId={internalId}
        key={index}
        sectionSize={sectionSize}
      />
    ));
  });
  return (
    <GeneralDialog
      open={props.open}
      handleClose={props.handleClose}
      handleConfirm={props.dialogHandleConfirm}
      title="Re-order sections"
    >
      <DragDropContext onDragEnd={props.onDragEnd}>
        <Droppable droppableId="list">
          {provided => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <ListOfDraggableSections sections={props.sections} />
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </GeneralDialog>
  );
};

export default ReorderSectionsDialogView;
